import {useState, useEffect, useRef} from 'react'
import {checkPath, checkFolderSizes} from './AM_ReaperConnectionSupport'
import { dBConn } from '../../API_GET'
/* PROFILE */

export const KRASTSettings = (props) => {

    const os = useRef(null)

    const [ksettings, setKsettings] = useState({
        tempFolder: null,
        audioEditor: null,
        applySettings: false
    })
  
    useEffect(() => {
        if (window?.electronAPI?.isElectronContainer){
            const platform = window?.electronAPI?.os.platform();
            os.current = platform === 'win32' ? 'pc' : 'mac';

            dBConn(`krastAM-app-load-settings=${os.current}`).then(async response => {
                const tempFolderCheck = await checkPath(response.tempFolder ?? null);
                const audioEditorCheck = await checkPath(response.audioEditor ?? null);
                const folderSizes = await checkFolderSizes(response.tempFolder ?? null);

                setKsettings(previous => ({
                ...previous, 
                tempFolder: response.tempFolder ?? null,
                tempFolderCheck,
                folderSizes,
                audioEditor: response.audioEditor ?? null,
                audioEditorCheck,
                }))
            })
        }
    }, [])

    const addTempPath = async () => {

        if (window?.electronAPI?.isElectronContainer){
            const folder = await window?.electronAPI?.openFolderDialog()
            if(folder){
                setKsettings(previous => ({ ...previous, applySettings: true, tempFolder: folder, tempFolderCheck: true}))
                // TODO: Add path logic here
            } 
        }
    }

    const addAudioEditor = async () => {
        if(window?.electronAPI?.isElectronContainer){

            const isWin = os.current === 'pc';
            const options = {
                properties: ['openFile'],
                filters: [
                    {name: isWin ? 'Executable' : 'Application', extensions: isWin ? ['exe'] : ['app']}
                ]
            }

            const file = await window?.electronAPI?.openFileDialog(options)
            
            if(!file.canceled && file.filePaths.length === 1){
                setKsettings(previous => ({ ...previous, applySettings: true, audioEditor: file.filePaths[0], audioEditorCheck: true }))
            }
        }
    }

    const applyKrastSettings = async () => {

    const settings = {
        os: os.current,
        settings: {
            tempFolder: ksettings.tempFolder ?? null,
            audioEditor: ksettings.audioEditor ?? null
        }
    }

    await dBConn('krastAM-app-save-settings', settings)

    if(props.amKRASTRef?.current) {
        await props.amKRASTRef.current.saveUserSettings({
            tempFolder: ksettings.tempFolder,
            audioEditor: ksettings.audioEditor,
        });
    }

    setKsettings(previous => ({ ...previous, applySettings: false }))
    
    props.toast.success('Settings Applied!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
    })

}

  return <div className="card">
            <div className="card-body">
              <h5 className="card-title">KRAST Settings</h5>
              <div className="row mb-3">
                  <label className="col-2">Audio Editor:</label>
                  <div className="col-10">
                    {ksettings.audioEditor 
                      ? ksettings.audioEditor 
                      : <span>No Audio Editor</span>
                    }
                    {ksettings.audioEditor && (!ksettings.audioEditorCheck ? 
                      <i className="bi bi-x-circle-fill ms-1"
                        style={{color: 'red'}}
                        title="Audio Editor not found"
                      />
                      :
                      <i className="bi bi-check-circle-fill ms-1"
                        style={{color: 'green'}}
                        title="Audio Editor found"
                      />
                      )}
                    <span style={{display: 'inline', position: 'relative', top: '-2px'}}>
                      <button onClick={addAudioEditor} 
                        className="btn btn-sm ms-1 text-primary"
                        title={ksettings.audioEditor ? 'Change Audio Editor' : 'Add Audio Editor'}>
                        <i className="bi bi-pencil"/>
                      </button>
                      {ksettings.audioEditor &&
                        <button 
                          onClick={() => setKsettings(prev => ({
                            ...prev,
                            audioEditor: null,
                            audioEditorCheck: false,
                            applySettings: true
                          }))}
                          className="btn btn-sm text-danger"
                          title="Remove Audio Editor">
                          <i className="bi bi-trash" />
                      </button>
                      }
                      </span>
                  </div>
              </div>



              <div className="row mb-3">
                  <label className="col-2">Temporary Folder:</label>
                  <div className="col-10">
                    {ksettings.tempFolder 
                      ? ksettings.tempFolder 
                      : "No Temporary Folder"
                    }
                    {ksettings.tempFolder && (!ksettings.tempFolderCheck ? 
                      <i className="bi bi-x-circle-fill ms-1"
                        style={{color: 'red'}}
                        title="Temporary Folder not found"
                      />
                      :
                      <i className="bi bi-check-circle-fill ms-1"
                        style={{color: 'green'}}
                        title="Temporary Folder found"
                      />
                      )}
                    <span style={{display: 'inline', position: 'relative', top: '-2px'}}>
                      <button 
                        onClick={addTempPath} 
                        className="btn btn-sm ms-1 text-primary"
                        title={ksettings.tempFolder ? 'Change Temporary Folder' : 'Add Temporary Folder'}>
                          <i className="bi bi-pencil"/>
                        </button>
                        {ksettings.tempFolder &&
                        <button 
                          onClick={() => setKsettings(prev => ({
                            ...prev,
                            tempFolder: null,
                            tempFolderCheck: false,
                            applySettings: true
                          }))}
                          className="btn btn-sm text-danger"
                          title="Remove Temporary Folder">
                          <i className="bi bi-trash" />
                        </button>
                      }
                      </span>
                      {ksettings.folderSizes && (
                        <div style={{fontSize: '11px', fontWeight: 'bold'}}>
                          {ksettings.folderSizes.fileCount === 0 ? 'No files' : 
                          <span>{ksettings.folderSizes.fileCount} files, {ksettings.folderSizes.totalSizeMB} MB 
                          <button 
                              style={{position: 'relative', fontSize: '11px', top: '-1px'}}
                              className="btn btn-sm p-0 ms-1 text-primary"
                              title="Clear Temporary Folder">
                              <i style={{fontSize: '11px'}} className="bi bi-trash" />
                            </button>
                          </span>}
                        </div>
                      )}
                  </div>
              </div>
              <div className="mt-6">
                <button 
                  className="btn btn-primary btn-sm" 
                  style={{width: '90px'}} 
                  disabled={!ksettings.applySettings}
                  onClick={applyKrastSettings}>Apply</button>
              </div>
            </div>
          </div>

}